<div style="padding-top: 24px;" (click)="selectSection()">
    <div class="d-flex flex-column" style="width: 100%; padding: 0px 5px; ">
        <div *ngFor="let currentRow of currentRows; let index = index" class="d-flex flex-column all-row  "
            (click)="currentRow.isInLayout() ? selectLayout($event,currentRow.layout,index) : true">

            <ng-container *ngIf="currentRow.isInitInLayout()" [ngTemplateOutlet]="addRowTemplate"
                [ngTemplateOutletContext]="{data:{hasLayout:true,index:index,afterRow:null,layout:null}}">
            </ng-container>

            <div class="d-flex flex-column " [class.row-layout-init]="currentRow.isInitInLayout()"
                [class.row-layout-last]="currentRow.isLastInLayout()"
                [class.row-layout-middle]="currentRow.isLastInLayout() ==false && currentRow.isInitInLayout() == false && currentRow.isInLayout()"
                (mouseenter)="onMouseLayout(currentRow.layout)" (mouseleave)="onMouseLayout(null)"
                [class.row-layout-over]="isInHoverLayout(currentRow)">

                <ng-container [ngTemplateOutlet]="rowHeader"
                    [ngTemplateOutletContext]="{data:{currentRow:currentRow,index:index,hasLayout:currentRow.isInLayout() == false,afterRow:currentRow,layout:currentRow.layout}}">
                </ng-container>

                <div class="d-flex" [class.inside-layout]="currentRow.isInLayout()"
                    [class.inside-row]="currentRow.isInLayout() == false" (click)="selectRow($event,currentRow,index)">

                    <div [id]="'editor-'+currentRow.id()" class="d-flex flex-column row-container"
                        style="flex: 1 0 0; padding: 1px; padding-bottom: 1px;">
                        <ng-container *ngIf="!currentRow.isInTable()" [ngTemplateOutlet]="widgetHeader"
                            [ngTemplateOutletContext]="{data:{currentRow:currentRow,index:index}}"></ng-container>

                        <ng-container [ngTemplateOutlet]="rowContent"
                            [ngTemplateOutletContext]="{data:{currentRow:currentRow,index:index}}"></ng-container>
                    </div>
                </div>

                <ng-container *ngIf="currentRow.isInLayout()" [ngTemplateOutlet]="addRowTemplate"
                    [ngTemplateOutletContext]="{data:{hasLayout:false,index:index,afterRow:currentRow,layout:currentRow.layout}}">
                </ng-container>

                <div [class.inside-layout]="currentRow.isLastInLayout()"
                    [class.inside-row]="currentRow.isInLayout() == false"
                    [style.min-height]="currentRow.isLastInLayout() ? '15px' :'0px'" style="min-width: 5px;">
                </div>
            </div>
        </div>

        <ng-container [ngTemplateOutlet]="addRowTemplate"
            [ngTemplateOutletContext]="{data:{hasLayout:true,index:currentRows.length,afterRow:null,layout:null,show:true}}">
        </ng-container>
    </div>
</div>

<ng-container *ngIf="(availableLines() == maxLines) && ddWidget == false" [ngTemplateOutlet]="empty"></ng-container>

<ng-template #widgetDDPreview let-data="data">
    <div class="d-flex flex-column justify-content-center align-items-center widget-dd-preview mat-elevation-z4">
        <mat-icon>{{data.widget?.icon()}}</mat-icon>
        <div class="widget-label">{{data.widget?.label()}}</div>
    </div>
</ng-template>

<ng-template #rowDDPreview>
    <div class="row-header widget-header d-flex justify-content-around mat-elevation-z4" style="visibility: visible !important;">
        <div class="d-flex justify-content-center align-items-center" style="cursor: move;">
            <mat-icon>drag_handle</mat-icon>
        </div>
        <button mat-icon-button>
            <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
        </button>
        <button mat-icon-button>
            <mat-icon class="material-icons-outlined">arrow_downward</mat-icon>
        </button>
        <button mat-icon-button>
            <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #addRowTemplate let-data="data">
    <div *ngIf="maxLines>currentRows.length && !isTableLayout(data.layout)" [class.inside-layout]="data.hasLayout==false"
        class="add-row-template-container" style="padding: 0px;">
        <div cdkDropList cdkDropListSortingDisabled [cdkDropListEnterPredicate]="isTool" cdkDropListConnectedTo="tools"
            (cdkDropListDropped)=" data.hasLayout ? dropCreateRow($event,data.index,data.afterRow,data.layout) : dropCreateRowLayout($event,data.index,data.afterRow,data.layout)"
            [class.last-add-row-template]="data.show" class="d-flex flex-column justify-content-center  "
            style="min-height: 24px; width: 100%;">

            <div widgetHolder [class.add-row-template-fixed]="data.show==true"
                [class.add-row-template]="data.show == null || data.show == false "
                class="d-flex justify-content-center align-items-center" style="height: 2px; width: 100%;">

                <button (click)="doRequestAddTool(data.hasLayout,data.index,data.afterRow,data.layout)"
                    mat-mini-fab color="primary" class="mat-elevation-z1">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #widgetDetail let-data="data">
    <div class="field-wrapper">
        <div class="d-flex align-items-stretch">
            <div class="widget-content-border" [class.element-selected]="ddService.elementSelected == data.widget"
                style="flex: 1 0 0; ">
                <div tabindex="0" class="d-flex flex-column widget-detail-content ">
                    <div class="d-flex" style="height: 100%; flex:1 0 0;">
                        <div style="position: relative;  min-height: 100px; ">
                            <div style="position: absolute; left: -6px; top: -1px; height: 100%;"
                                class="widget-menu d-flex flex-column justify-content-center align-items-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <mat-icon>drag_handle</mat-icon>
                                </div>
                                <button mat-icon-button
                                    (click)="removeWidget(data.currentRow,data.widget,data.index);$event.stopPropagation();">
                                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                                </button>
                                <button mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
                                    <mat-icon>more_horiz</mat-icon>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item
                                            (click)="moveWidget(data.currentRow,data.index,data.index-1);$event.stopPropagation(); menuTrigger.closeMenu();">
                                            <mat-icon>arrow_backward</mat-icon> Esquerra
                                        </button>
                                        <button mat-menu-item
                                            (click)="moveWidget(data.currentRow,data.index,data.index+1);$event.stopPropagation();menuTrigger.closeMenu();">
                                            <mat-icon>arrow_forward</mat-icon> Dreta
                                        </button>
                                        <button mat-menu-item
                                            (click)="selectWidget($event,data.currentRow,data.widget,data.index);$event.stopPropagation();menuTrigger.closeMenu();">
                                            <mat-icon class="material-icons-outlined">edit</mat-icon> Editar
                                        </button>
                                        <button mat-menu-item
                                            (click)="removeWidget(data.currentRow,data.widget,data.index);$event.stopPropagation();menuTrigger.closeMenu();">
                                            <mat-icon class="material-icons-outlined">delete</mat-icon> Esborrar
                                        </button>
                                    </mat-menu>
                                </button>
                            </div>
                        </div>
                        <div [id]="'editor-'+data.widget.id()"
                            class="widget-content-body d-flex flex-column align-items-center  justify-content-center "
                            style="flex:1 0 0;">
                            <mat-icon class="material-icons-outlined">{{data.widget?.icon()}}</mat-icon>
                            <div class="widget-label">{{data.widget?.label()}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #rowHeader let-data="data">
    <div [class.inside-layout]="data.currentRow.isInLayout()"
        [style.min-height]="data.currentRow.isInitInLayout() ? '22px' :'0px'" style="min-width: 5px;">

        <div *ngIf="data.currentRow.isInitInLayout()" cdkDropList [cdkDropListEnterPredicate]="isRow"
            [cdkDropListData]="currentRows" (cdkDropListDropped)="dropRow($event,data.index)">

            <div class="d-flex justify-content-around align-items-center"
                [cdkDragData]="{type:'row',id:data.index,layout:true}"
                (cdkDragStarted)="startDDRow($event);ddRowLayout=true;"
                (cdkDragEnded)="endDDrow($event);ddRowLayout=false;" cdkDrag>

                <ng-container [ngTemplateOutlet]="layoutInit"
                    [ngTemplateOutletContext]="{data:{currentRow:data.currentRow,index:data.index}}"></ng-container>
            </div>
        </div>
    </div>
    <ng-container *ngIf="data.currentRow.isInLayout() ==false" [ngTemplateOutlet]="addRowTemplate"
        [ngTemplateOutletContext]="{data:{hasLayout:data.currentRow.isInLayout() == false,index:data.index,afterRow:data.currentRow,layout:data.currentRow.layout}}">
    </ng-container>
</ng-template>

<ng-template #layoutInit let-data="data">
    <div class="layout-init d-flex flex-column" style="flex:1 0 0;">
        <div style="position: relative;">
            <div class="widget-layout-init-menu d-flex justify-content-around align-items-center" [class.widget-layout-init-menu-table]="data.currentRow.isInTable()">
                <mat-icon>drag_handle</mat-icon>
                <button mat-icon-button
                    (click)="rowUpLayout(data.currentRow.layout,data.index);$event.stopPropagation();">
                    <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
                </button>
                <button mat-icon-button
                    (click)="rowDownLayout(data.currentRow.layout,data.index);$event.stopPropagation();">
                    <mat-icon class="material-icons-outlined">arrow_downward</mat-icon>
                </button>
                <button *ngIf="data.currentRow.isInTable()" mat-icon-button (click)="removeRow(data.currentRow);$event.stopPropagation();">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-start align-items-center" style="height: 36px; padding: 8px;">
            <mat-icon>{{data.currentRow.layout.icon}}</mat-icon>
            <div class="widget-label mat-subheading-1" style="padding-left: 10px;">
                {{data.currentRow.layout.label()}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #widgetHeader let-data="data">
    <div style="position: relative;">
        <div class="widget-header-container">
            <div cdkDropList [cdkDropListEnterPredicate]="data.currentRow.isInLayout() ? isRowNotLayout: isRow"
                [cdkDropListData]="currentRows" (cdkDropListDropped)="dropRow($event,data.index)"
                [class.dd-row]="ddRow&&(data.currentRow.isInLayout() ? data.currentRow.isInLayout()&&!ddRowLayout:true)">
                <div [cdkDragData]="{type:'row',id:data.index}"
                    class="row-header widget-header d-flex justify-content-around align-items-center"
                    (cdkDragStarted)="startDDRow($event)" (cdkDragEnded)="endDDrow($event)" cdkDrag>

                    <div class="d-flex justify-content-center align-items-center" style="cursor: move;">
                        <mat-icon>drag_handle</mat-icon>
                    </div>
                    <button mat-icon-button (click)="rowToUp(data.currentRow,data.index);$event.stopPropagation();">
                        <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
                    </button>
                    <button mat-icon-button (click)="rowToDown(data.currentRow,data.index);$event.stopPropagation();">
                        <mat-icon class="material-icons-outlined">arrow_downward</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeRow(data.currentRow)">
                        <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>
                    <ng-template cdkDragPreview matchSize="true">
                        <ng-container [ngTemplateOutlet]="rowDDPreview">

                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #rowContent let-data="data">
    <div cdkDropList [cdkDropListEnterPredicate]="isNotRow" [cdkDropListData]="data.currentRow"
        cdkDropListOrientation="horizontal" class="example-list align-items-center row-content"
        [class.dd-widget]="ddService.ddElement!=null&&data.currentRow.thereIsAvailableSlots(ddService.ddElement.slotWeight())"
        (cdkDropListDropped)="drop($event)">

        <div *ngFor="let widget of data.currentRow.widgets; let index = index"
            class="d-flex justify-content-center example-box" style="flex-grow:1; height: 120px;"
            (click)="selectWidget($event,data.currentRow,widget,index)" (cdkDragStarted)="startDDWidget($event,widget)"
            (cdkDragEnded)="endDDWidget($event)" cdkDrag>

            <ng-container [ngTemplateOutlet]="widgetDetail"
                [ngTemplateOutletContext]="{data:{currentRow:data.currentRow,widget:widget,index:index,isLast:index==data.currentRow.widgets.length-1}}">
            </ng-container>

            <ng-template cdkDragPreview matchSize="true">
                <ng-container [ngTemplateOutlet]="widgetDDPreview" [ngTemplateOutletContext]="{data:{widget:widget}}">
                </ng-container>
            </ng-template>
        </div>
    </div>
</ng-template>

<ng-template #empty>
    <app-page-empty-search-result 
        [description]="'Simplement arrossega els camps que vulguis dins d\'aquesta àrea. Des d\'aquí podràs distribuir-los i editar-los.'" 
        iconName="visibility" image="section"></app-page-empty-search-result>
</ng-template>